import { apply, call, put, select, takeEvery } from 'redux-saga/effects';
import * as Types from './../actions/constants';
import usersActions from './../actions/usersActions';
import feathers from './../../services/FeathersService';

const ManageUsersService = feathers.service('api/manage-users');

function* findUsers ({ payload }) {
  try {
    let response = yield call([ManageUsersService, 'find'], {
      query: {
        ...payload
      }
    });

    yield put(usersActions.users.findSuccess(response.data, response.limit, response.skip, response.total));
  } catch (e) {
    yield put(usersActions.users.findFailure(e));
  }
}

function* removeUser ({ payload }) {
  try {
    yield call([ManageUsersService, 'remove'], payload.id);

    yield put(usersActions.users.removeSuccess(payload.id));
  } catch (e) {
    yield put(usersActions.users.removeFailure(e));
  }
}

function* upsertUser ({ payload }) {
  try {
    let user = {};
    let state = yield select();
    let {
      records
    } = state.users.toJS({ deep: true });

    if (payload.values.id) {
      user = yield call([ManageUsersService, 'patch'], payload.values.id, payload.values);
    } else {
      user = yield call([ManageUsersService, 'create'], payload.values);
    }

    yield put(usersActions.users.upsertSuccess(user));
    yield put(usersActions.users.resetForm());
    yield put(usersActions.users.findAttempt(records.filters, records.limit, records.skip));
    yield put(usersActions.users.toggleUpsertModal());
  } catch (e) {
    yield put(usersActions.users.upsertFailure(e));
  }
}

export default function* watchUsersActions () {
  yield takeEvery(Types.FIND_USERS_ATTEMPT, findUsers);
  yield takeEvery(Types.REMOVE_USER_ATTEMPT, removeUser);
  yield takeEvery(Types.UPSERT_USER_ATTEMPT, upsertUser);
}


// WEBPACK FOOTER //
// ./client/store/sagas/usersSaga.js